import { defineNuxtRouteMiddleware, abortNavigation } from '#imports';
import { usePageContent } from '@/composables/usePageContent';
import { useAnchorTag } from '@/composables/useAnchorTag';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { handlePageData } = usePageContent();
  const { validateAnchorRoute, scrollToAnchor } = useAnchorTag();

  try {
    const isAnchorChange = validateAnchorRoute(to, from);
    if (isAnchorChange) {
      // Fire-and-forget: don't block route completion while waiting for the
      // anchor element. For same-page navigation it's already in the DOM so
      // the scroll happens immediately; if the anchor is missing, the route
      // still resolves rather than hanging for ANCHOR_WAIT_TIMEOUT_MS.
      scrollToAnchor(to.hash);
      return;
    }

    await handlePageData(to, from);
    // scrollToAnchor for cross-page navigation is handled by the pageLoaded
    // event in index.vue, which fires after the page component has mounted and
    // the anchor element is already in the DOM. Calling it here (before Vue
    // renders) forces waitForAnchorElement to poll for the element, adding a
    // visible delay on pages with lots of content.
  } catch {
    return abortNavigation({
      statusCode: 404,
      message: 'Page not found',
    });
  }
});
